// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__98nxB","title":"Info_title__2g4fk","links":"Info_links__1e6A1","link":"Info_link__3sX_V","logo":"Info_logo__2Knyh"};